import axios from 'axios';

const getAdminPrompts  = () => {
  const url = process.env.REACT_APP_API_URL + 'admin-prompts';

  return axios.get(url, {
    headers: {
      accept: 'application/json',
    },
  });
};


/**
 * Sends a POST request to create an admin prompt.
 * @param {Object} requestBody - The JSON payload with properties to spread into the final body.
 * @returns {Promise} - A Promise that resolves with the response or rejects with an error.
 */
const createAdminPrompt = async ({ prompt_name, prompt_slug, versions }) => {
  const url = process.env.REACT_APP_API_URL + 'admin-prompts';
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  };

  // Construct the final request body
  const body = {
    prompt_name,
    prompt_slug,
    prompt_versions: [...versions], // Spread the versions array
  };

  try {
    const response = await axios.post(url, body, { headers });
    return response.data;
  } catch (error) {
    console.error('Error:', error.response ? error.response.data : error.message);
    throw error;
  }
}


export {getAdminPrompts, createAdminPrompt};